export default __webpack_public_path__ + "static/media/dp-extr-python.ada3d1d7.png";